export default __webpack_public_path__ + "static/rich-text-0a7844af3bfeff78c875b69f0a43db7a.webp";